import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createUser,
  getEmailForTemplate,
} from "../../../store/slices/AdminSlice/AdminSlice";
import { useNavigate } from "react-router-dom";

export default function CreateUser() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { templateUsers } = useSelector((state) => state.admin);

  const [form, setForm] = useState({
    email: "",
    first_name: "",
    last_name: "",
    password: "",
    customer_number: "",
    company_code: "M",
    template: "",
    must_change_password: true, // always true
    email_validated: true, // always true
  });
  const [success, setSuccess] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
    setSuccess("");
    const result = await dispatch(createUser(form));
    setLoading(false);
    if (result.error) {
      if (result.payload?.errors) setErrors(result.payload.errors);
      else if (result.payload?.error)
        setErrors({ general: result.payload.error });
      else setErrors({ general: "Unknown error" });
    } else {
      setSuccess("User created successfully!");
      setForm({
        email: "",
        first_name: "",
        last_name: "",
        password: "",
        customer_number: "",
        company_code: "M",
        template: "",
        must_change_password: true,
        email_validated: true,
      });
    }
  };

  useEffect(() => {
    dispatch(getEmailForTemplate());
  }, [dispatch]);

  return (
    <div className="max-w-lg mx-auto p-6 bg-white rounded shadow">
      <h2 className="text-xl font-bold mb-4">Create New User</h2>
      <div className="mb-2 text-blue-700 text-sm">
        The user will be required to change their password on their first login.
        <br />
        The user must validate their email before they can access their account.
      </div>
      {success && <div className="mb-4 text-green-600">{success}</div>}
      {errors.general && (
        <div className="mb-4 text-red-600">{errors.general}</div>
      )}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block font-medium">Email</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1"
            required
          />
          {errors.email && (
            <div className="text-red-600 text-xs">{errors.email}</div>
          )}
        </div>
        <div>
          <label className="block font-medium">First Name</label>
          <input
            type="text"
            name="first_name"
            value={form.first_name}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1"
            required
          />
          {errors.first_name && (
            <div className="text-red-600 text-xs">{errors.first_name}</div>
          )}
        </div>
        <div>
          <label className="block font-medium">Last Name</label>
          <input
            type="text"
            name="last_name"
            value={form.last_name}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1"
            required
          />
          {errors.last_name && (
            <div className="text-red-600 text-xs">{errors.last_name}</div>
          )}
        </div>

        <div>
          <label className="block font-medium">Customer Number</label>
          <input
            type="text"
            name="customer_number"
            value={form.customer_number}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1"
            required
          />
          {errors.customer_number && (
            <div className="text-red-600 text-xs">{errors.customer_number}</div>
          )}
        </div>
        <div>
          <label className="block font-medium mb-1">Template User</label>
          <select
            name="template"
            value={form.template}
            onChange={handleChange}
            className="w-full border rounded px-2 py-1"
          >
            <option value="">Select a template user (optional)</option>
            {templateUsers &&
              templateUsers.map((email, index) => (
                <option key={index} value={email}>
                  {email}
                </option>
              ))}
          </select>
          <div className="text-xs text-gray-500 mt-1">
            Select a template user to copy settings from (optional)
          </div>
        </div>
        <div className="flex gap-5">
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
            disabled={loading}
          >
            {loading ? "Creating..." : "Create User"}
          </button>

          <button
            type="button"
            className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
            onClick={() => navigate("/settings/user-admin")}
          >
            Back to Settings
          </button>
        </div>
      </form>
    </div>
  );
}
